import React from 'react';
import firebase from 'firebase/compat/app';
import { UserMenu } from '../UserMenu/UserMenu';
import { Socket } from 'socket.io-client';
import { Comment, Icon } from 'semantic-ui-react';
import styles from './Chat.module.css';
import classes from './Chat.module.css';
import { getColorForStringHex, getDefaultPicture } from '../../utils';

interface IParticipants {
  nameMap: StringDict;
  owner: string | undefined;
  roomId: string;
  user: firebase.User | undefined;
  pictureMap: StringDict;
  uniqueUids: string[];
  socket: Socket;
}

const Participants: React.FC<IParticipants> = ({
  nameMap,
  pictureMap,
  owner,
  roomId,
  socket,
  user,
  uniqueUids,
}) => {
  return (
    <div className="text-white max-h-[575px] overflow-auto">
      {uniqueUids.map((uid, uidIndex) => {
        return (
          <div
            key={uidIndex}
            className="relative overflow-hidden p-[1px] after:content-[''] after:absolute after:inset-0 after:rounded-xl after:p-[5px] after:pointer-events-none after:z-0 gradient-pink-border w-full mb-3"
          >
            <div className="relative z-[1] overflow-hidden rounded-xl bg-[#040404] flex items-center justify-between gap-2 p-3 w-full">
              <div className="flex items-center gap-2">
                <div
                  className="mainProfileBox tenMember relative flex-shrink-0"
                  title="WatchParty Plus subscriber"
                >
                  <div className="size-[46px] p-px rounded-full relative z-[5]">
                    <img
                      className="userProfile size-full rounded-full border-2 border-green-500 object-cover"
                      src={
                        pictureMap[uid] ||
                        getDefaultPicture(
                          nameMap[uid],
                          getColorForStringHex(uid)
                        )
                      }
                      alt="userAvatar"
                    />
                    <div className="size-5 absolute -right-[2px] -top-[2px] after:content-['10K'] after:absolute after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:text-[6px] after:font-['Poppins'] after:font-bold after:flex after:items-center after:justify-center after:bg-white after:rounded-full after:px-[2px] after:text-black after:h-[9px]">
                      <svg
                        fill="#27ae60"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <span>{nameMap[uid]}</span>
              </div>

              <UserMenu
                displayName={nameMap[uid] || uid}
                user={user}
                timestamp={new Date().getMilliseconds().toString()}
                socket={socket}
                userToManage={user?.uid || uid}
                isChatMessage={false}
                owner={owner}
                chatUserId={user?.uid ?? ''}
                from={'participants'}
                disabled={!Boolean(owner && owner === user?.uid)}
                trigger={
                  <Comment.Author as="a" className={styles.light}>
                    {Boolean(false) && 'System'}
                    <button className="text-[22px] text-[#B5B5BE]">
                      <svg
                        width="22"
                        height="6"
                        viewBox="0 0 22 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.75535 0.802154C4.0565 0.802154 5.11128 1.8538 5.11128 3.15108C5.11128 4.44835 4.0565 5.5 2.75535 5.5C1.4542 5.5 0.399414 4.44835 0.399414 3.15108C0.399414 1.8538 1.4542 0.802154 2.75535 0.802154ZM11.001 0.801955C12.3022 0.801955 13.357 1.8536 13.357 3.15088C13.357 4.44815 12.3022 5.4998 11.001 5.4998C9.69987 5.4998 8.64508 4.44815 8.64508 3.15088C8.64508 1.8536 9.69987 0.801955 11.001 0.801955ZM21.6016 3.15088C21.6016 1.8536 20.5468 0.801955 19.2456 0.801955C17.9445 0.801955 16.8897 1.8536 16.8897 3.15088C16.8897 4.44815 17.9445 5.4998 19.2456 5.4998C20.5468 5.4998 21.6016 4.44815 21.6016 3.15088Z"
                          fill="#828282"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.75535 0.802154C4.0565 0.802154 5.11128 1.8538 5.11128 3.15108C5.11128 4.44835 4.0565 5.5 2.75535 5.5C1.4542 5.5 0.399414 4.44835 0.399414 3.15108C0.399414 1.8538 1.4542 0.802154 2.75535 0.802154ZM11.001 0.801955C12.3022 0.801955 13.357 1.8536 13.357 3.15088C13.357 4.44815 12.3022 5.4998 11.001 5.4998C9.69987 5.4998 8.64508 4.44815 8.64508 3.15088C8.64508 1.8536 9.69987 0.801955 11.001 0.801955ZM21.6016 3.15088C21.6016 1.8536 20.5468 0.801955 19.2456 0.801955C17.9445 0.801955 16.8897 1.8536 16.8897 3.15088C16.8897 4.44815 17.9445 5.4998 19.2456 5.4998C20.5468 5.4998 21.6016 4.44815 21.6016 3.15088Z"
                          fill="black"
                          fill-opacity="0.2"
                        />
                      </svg>
                    </button>
                  </Comment.Author>
                }
                roomId={roomId}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Participants;
